module.exports = require("./lib/_stream_transform.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/node-libs-browser/~/readable-stream/transform.js
 ** module id = 1663
 ** module chunks = 0
 **/